module.exports = __webpack_public_path__ + "img/mco.e46fb10d.svg";